export default __webpack_public_path__ + "static/media/chevron--right.b956101b.svg";